// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn___1Okce","btn--long":"btn--long___3ny2p","btnLong":"btn--long___3ny2p","btn--purple":"btn--purple___1NhA8","btnPurple":"btn--purple___1NhA8"};